import i18n from "@/zapi-frontend/shared/i18n";

// Default version names are stored in English ("Initial", "Initial V2", "New Version 3") because they
// are read back to number the next version, so only the displayed text is translated.
export function displayVersionName(name: string | null | undefined): string {
  if (!name) return "";
  const initial = /^Initial( V\d+)?$/.exec(name);
  if (initial) return `${i18n.t("projectHome:projectSetup.versionInitial")}${initial[1] ?? ""}`;
  const newVersion = /^New Version( \d+)?$/.exec(name);
  if (newVersion) return `${i18n.t("common:versions.newTitle")}${newVersion[1] ?? ""}`;
  return name;
}
